import getTodoRequestHeaders from './getTodoRequestHeaders';
import { format } from 'owa-strings';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makeDeleteRequest } from 'owa-ows-gateway';
import { TODO_API_DELETE_TASK_FORMAT } from './constants';

export default function deleteTaskService(itemId: string): Promise<boolean> {
    const url = format(TODO_API_DELETE_TASK_FORMAT, itemId);
    return makeDeleteRequest(
        url,
        null /* requestObject */,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders() /* customHeaders */
    )
        .then((response: Response) => {
            return isSuccessStatusCode(response.status);
        })
        .catch(err => {
            return false;
        });
}
